<script>
	// import { line, curveStep, scaleLinear, timeParse, extent, scaleTime } from 'd3';
	import { scaleLinear } from 'd3-scale';
	import { trendPointsFromAnalysis } from '../../scripts/alfxSurvey.js';
    // Using D3 in svelte: https://www.connorrothschild.com/post/svelte-and-d3
    // Intro:  https://dev.to/learners/series-intro-data-visualization-with-svelte-and-d3-4c07
    // Svelte bar chart: https://svelte.dev/repl/8722c32f4e1a44a98e3a3fc8a095b2d7?version=3.5.3
    // Svelte line graph: https://svelte.dev/repl/8262eb73a08f48adba8e0b706c1a939f?version=3.22.1

    const yTicks = [0, 0.25, 0.5, 0.75, 1];
	const xTicks = [0, 3600, 7200, 10800, 14400];
	const padding = { top: 20, right: 15, bottom: 20, left: 25 };
	export let analysis;
	let points;
    let width = 500;
	let height = 200;
	
	$: points= trendPointsFromAnalysis(analysis);

    $: xScale = scaleLinear()
		.domain([minX, maxX])
		.range([padding.left, width - padding.right]);

    $: yScale = scaleLinear()
		.domain([Math.min.apply(null, yTicks), Math.max.apply(null, yTicks)])
		.range([height - padding.bottom, padding.top]);

    $: minX = (points.length > 0) ? points[0].x : 0;
	$: maxX = (points.length > 0) ? points[points.length - 1].x : 0;
	$: path = `M${points.map(p => `${xScale(p.x)},${yScale(p.y)}`).join('L')}`;
	$: area = `${path}L${xScale(maxX)},${yScale(0)}L${xScale(minX)},${yScale(0)}Z`;

    function formatMobile (tick) {
        const tickText = {0: "12:00 AM", 3600: "1:00 AM", 7200: "2:00 AM", 10800: "3:00 AM", 14400: "4:00 AM"}[tick];
        return tickText;
	}
</script>

<div class="detail-section">
    <div class="sensor-data-title">Nighttime Sound</div>
    {#if points.length > 0}
        <div class="chart" bind:clientWidth={width} bind:clientHeight={height}>
            <svg>
                <!-- y axis -->
                <g class="axis y-axis" transform="translate(0, {padding.top})">
                    {#each yTicks as tick}
                        <g class="tick tick-{tick}" transform="translate(0, {yScale(tick) - padding.bottom})">
                            <line x2="100%"></line>
                            <text y="-4">{tick} {tick === 100 ? ' Sound History' : ''}</text>
                        </g>
                    {/each}
                </g>

                <!-- x axis -->
                <g class="axis x-axis">
                    {#each xTicks as tick}
                        <g class="tick tick-{ tick }" transform="translate({xScale(tick)},{height})">
                            <line y1="-{height}" y2="-{padding.bottom}" x1="0" x2="0"></line>
                            <text y="-2">{formatMobile(tick)}</text>
                        </g>
                    {/each}
                </g>

                <!-- data -->
                <path class="path-area" d={area}></path>
                <path class="path-line" d={path}></path>
            </svg>
        </div>
    {:else}
        <div class="sensor-data-unavailable">
            <p>Nighttime variation unavailable</p>
        </div>
    {/if}
</div>

<style>
	.chart {
		width: 90%;
		max-width: 500px;
		margin-left: auto;
		margin-right: auto;
	}
	svg {
		position: relative;
		width: 100%;
		height: 200px;
		overflow: visible;
	}
	.tick {
		font-size: .725em;
		font-weight: 200;
	}
	.tick line {
		stroke: #aaa;
		stroke-dasharray: 2;
	}
	.tick text {
		fill: #666;
		text-anchor: start;
	}
	.tick.tick-0 line {
		stroke-dasharray: 0;
	}
	.x-axis .tick text {
		text-anchor: middle;
	}
	.path-line {
		fill: none;
		stroke: rgb(0,100,100);
		stroke-linejoin: round;
		stroke-linecap: round;
		stroke-width: 2;
	}
	.path-area {
		fill: rgba(0,100,100,0.2);
	}
</style>